import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { ThemeProvider } from './contexts/ThemeContext'
import './index.css'
import './styles/print.css'
import App from './App.tsx'
import { cleanupStaleServiceWorker } from './utils/serviceWorkerCleanup'
import { initializeSentry } from './utils/analytics/errorTracking'

// Initialize error tracking and monitoring
initializeSentry();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </StrictMode>,
)

// Clean up the half-built service worker (commit 9470efe) for existing visitors
void cleanupStaleServiceWorker();
